import React, { FC } from 'react';
import { Editor } from '@tinymce/tinymce-react';

interface IProps {
  placeholder: string;
  onChange: (content: string) => void; // 추가
}

const TextEditor: FC<IProps> = ({ placeholder, onChange }) => {
  return (
    <Editor
      apiKey="6byhs6s8gnz2o87blz4wwc7eqg80g7v95twpd9i8ewtdzxpw"
      id="tinyMce_editor"
      initialValue={placeholder}
      init={{
        height: 500,
        resize: false,
        menubar: false,
        quickbars_insert_toolbar: false,
        plugins: [
          'lists',
          'link',
          'image',
          'charmap',
          'preview',
          'searchreplace',
          'fullscreen',
          'media',
          'table',
          'code',
          'help',
          'emoticons',
          'codesample',
          'quickbars',
        ],
        toolbar:
          'undo redo | blocks | ' +
          'bold italic forecolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | ' +
          'lists table link charmap searchreplace | ' +
          'image media codesample emoticons fullscreen preview | ' +
          'removeformat | help ',
      }}
      onEditorChange={(content) => onChange(content)} // 변경된 내용 전달
    />
  );
};

export default TextEditor;
